<template>
  <div>
    <div class="mb-3">โปรดกรอกข้อมูลผู้เอาประกันภัย</div>

    <ValidationObserver ref="observer">
      <ValidationProvider
        name="เลขบัตรประจำตัวประชาชน"
        :rules="{
          required: true,
          regex: /^[0-9-]{13}|(?!^0+$)[a-zA-Z0-9]{3,20}$/,
          idcard: true,
          integer: true,
        }"
        v-slot="{ errors, valid }"
      >
        <div class="mb-4">
          <div class="font-weight-bold">เลขบัตรประชาชน <span class="red--text">*</span></div>
          <v-text-field
            dense
            @input="input.card_number = numberOnly($event)"
            v-model.number="input.card_number"
            maxlength="17"
            label
            v-mask="'X-XXXX-XXXXX-XX-X'"
            onkeypress="return event.charCode >= 48 && event.charCode <= 57"
            outlined
            :error-messages="errors"
            :success="valid"
            :hide-details="errors.length == 0"
          ></v-text-field>
        </div>
      </ValidationProvider>
      <div class="mb-4">
        <div class="font-weight-bold">ชื่อ-นามสกุล <span class="red--text">*</span></div>
        <v-row dense>
          <v-col cols="6">
            <ValidationProvider
              name="ชื่อจริง"
              :rules="{
                required: true,
              }"
              v-slot="{ errors, valid }"
            >
              <v-text-field
                dense
                v-model="input.first_name"
                label
                outlined
                :error-messages="errors"
                :success="valid"
                :hide-details="errors.length == 0"
              ></v-text-field>
            </ValidationProvider>
          </v-col>
          <v-col cols="6">
            <ValidationProvider
              name="นามสกุล"
              :rules="{
                required: true,
              }"
              v-slot="{ errors, valid }"
            >
              <v-text-field
                dense
                v-model="input.last_name"
                label
                outlined
                :error-messages="errors"
                :success="valid"
                :hide-details="errors.length == 0"
              ></v-text-field>
            </ValidationProvider>
          </v-col>
        </v-row>
      </div>
      <div class="mb-4">
        <div class="font-weight-bold">เบอร์โทร <span class="red--text">*</span></div>
        <ValidationProvider
          name="เบอร์โทรศัพท์"
          :rules="{ required: true, regex: /^[0][3-9][0-9]-[0-9]{3}-[0-9]{4}$/ }"
          v-slot="{ errors, valid }"
        >
          <v-text-field
            dense
            ref="mobilephone"
            v-model="input.phone_number"
            v-mask="'###-###-####'"
            label
            type="tel"
            outlined
            :error-messages="errors"
            :success="valid"
            :hide-details="errors.length == 0"
          ></v-text-field>
        </ValidationProvider>
      </div>
      <div class="mb-4">
        <div class="font-weight-bold">อีเมล</div>
        <ValidationProvider
          name="อีเมล"
          :rules="{ required: false, email: true }"
          v-slot="{ errors, valid }"
        >
          <v-text-field
            dense
            v-model="input.email"
            label
            outlined
            :error-messages="errors"
            :success="input.email ? valid : false"
            :hide-details="errors.length == 0"
          ></v-text-field>
        </ValidationProvider>
      </div>
      <ValidationProvider
        name="ช่องทางการรับเงิน"
        :rules="{
          required: true,
        }"
        v-slot="{ errors, valid }"
      >
        <div class="mb-4">
          <div class="font-weight-bold">
            กรุณาเลือกช่องทางการขอรับเงินผลประโยชน์ตามกรมธรรม์ที่ท่านต้องการ
          </div>
          <v-radio-group
            color="primary"
            v-model="input.receive_type"
            :error-messages="errors"
            :success="valid"
            :hide-details="errors.length == 0"
          >
            <v-radio class="mb-4" color="primary" value="prompt_pay">
              <template v-slot:label>
                <div style="color: black; font-size: 16px; font-weight: 400">
                  รับผ่านบัญชี Prompt pay ที่สมัครโดยใช้เลขที่บัตรประชาชน
                </div>
              </template>
            </v-radio>
            <v-radio class="mb-4" color="primary" value="bank_account">
              <template v-slot:label>
                <div style="color: black; font-size: 16px; font-weight: 400">
                  รับผ่านบัญชีธนาคาร
                </div>
              </template>
            </v-radio>
          </v-radio-group>
        </div>
      </ValidationProvider>
      <div class="text-center mt-10">
        <v-btn @click="next" class="px-10" color="primary" small depressed>
          <span style="font-size: 18px">ยืนยัน</span>
        </v-btn>
      </div>
    </ValidationObserver>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { mask } from "vue-the-mask";

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    mask,
  },
  data() {
    return {
      input: {
        card_number: "",
        first_name: "",
        last_name: "",
        phone_number: "",
        email: "",
        receive_type: null,
      },
    };
  },
  methods: {
    async next() {
      var isValid = await this.$refs.observer.validate();
      if (isValid) {
        Object.assign(this.$store.state.input, this.input);
        this.$store.state.step++;
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
